import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ForcePasswordChange from "../pages/ForcePasswordChange";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[var(--text-muted)] font-data text-sm">
        <span className="dot-pulse mr-3" />
        CHARGEMENT...
      </div>
    );
  }
  if (!user) return <Navigate to="/portail-admin" replace />;
  // Force password change for newly invited users before they can do anything else
  if (user.must_change_password) return <ForcePasswordChange />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/admin" replace />;
  return children;
}
